import { User } from '../../types';

interface OwnProps {
  user?: User | null;
  size?: 'sm' | 'md' | 'lg';
}

const UserAvatar = (props: OwnProps) => {
  const { user, size = 'md' } = props;
  const { name } = user || {};
  const avatarImageUrl =
    (user as { avatarImageUrl?: string | null; avatar?: string | null } | null | undefined)?.avatarImageUrl ||
    (user as { avatarImageUrl?: string | null; avatar?: string | null } | null | undefined)?.avatar ||
    '';
  
  const sizeClasses = {
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
  };

  return (
    <div className={`${sizeClasses[size]} rounded-full bg-[#1F7A78]/10 flex items-center justify-center text-[#1F7A78] font-medium overflow-hidden`}>
      {avatarImageUrl ? (
        <img src={avatarImageUrl} alt={name} className="h-full w-full object-cover" />
      ) : (
        <span>{name?.charAt(0).toUpperCase() || "U"}</span>
      )}
    </div>
  )
}

export default UserAvatar;
